import { render, staticRenderFns } from "./LoadingPoints.vue?vue&type=template&id=3a9cf6b5"
import script from "./loadingPoints.ts?vue&type=script&lang=js&external"
export * from "./loadingPoints.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports